// Normaliza el bloque de tarjetas (KPI + topProductos)
export const normalizeTarjetasData = (raw) => {
  const r =
    raw?.tarjetaDashboardDtoHelperResponse ??
    raw?.tarjetasDashboardDto ??
    raw ?? {};

  const pick = (a, b) => (a !== undefined ? a : b);

  const ventasDelMes = Number(pick(r.ventasDelMes, r.VentasDelMes) ?? 0);
  const comisionVentas = Number(pick(r.comisionVentas, r.ComisionVentas) ?? 0);
  const ticketPromedio = Number(pick(r.ticketPromedio, r.TicketPromedio) ?? 0);

  const unidadesVendidas = Number(pick(r.unidadesVendidas, r.UnidadesVendidas) ?? 0);

  const variacionMensualVentas = Number(pick(r.variacionMensualVentas, r.VariacionMensualVentas) ?? 0);
  const variacionMensualUnidades = Number(pick(r.variacionMensualUnidades, r.VariacionMensualUnidades) ?? 0);
  const variacionAnualVentas = Number(pick(r.variacionAnualVentas, r.VariacionAnualVentas) ?? 0);
  const variacionAnualUnidades = Number(pick(r.variacionAnualUnidades, r.VariacionAnualUnidades) ?? 0);

  const topRaw = r.topProductoDtoResponse ?? r.topProductos ?? r.TopProductoDtoResponse ?? [];
  const topProductos = Array.isArray(topRaw)
    ? topRaw.map(p => ({
      codigoProducto: p.codigoProducto ?? p.CodigoProducto ?? '',
      nombreProducto: p.nombreProducto ?? p.NombreProducto ?? '',
      unidadesVendidas: Number(p.unidadesVendidas ?? p.UnidadesVendidas ?? 0),
      montoVentas: Number(p.montoVentas ?? p.MontoVentas ?? 0),
      idPublicacion: p.idPublicacion ?? p.IdPublicacion ?? null,
      idSeller: p.idSeller ?? p.IdSeller ?? null,
    }))
    : [];

  return {
    ventasDelMes,
    comisionVentas,
    ticketPromedio,
    unidadesVendidas,
    variacionMensualVentas,
    variacionMensualUnidades,
    variacionAnualVentas,
    variacionAnualUnidades,
    topProductos,
  };
};

// Pie de estados
export const buildPieData = (resumenEstadosOrden) => {
  const r = resumenEstadosOrden || { total: 0, facturadas: 0, pendienteFacturar: 0, anuladas: 0 };
  return {
    labels: ['Facturadas', 'Pendiente facturar', 'Anuladas'],
    datasets: [{
      label: 'Órdenes por estado',
      data: [
        Number(r.facturadas ?? r.Facturadas ?? 0),
        Number(r.pendienteFacturar ?? r.PendienteFacturar ?? 0),
        Number(r.anuladas ?? r.Anuladas ?? 0),
      ],
      backgroundColor: [
        'rgba(76, 175, 80, 0.85)',
        'rgba(255, 195, 0, 0.88)',
        'rgba(230, 52, 9, 0.82)',
      ],
      borderColor: [
        'rgba(76, 175, 80, 1)',
        'rgba(255, 195, 0, 1)',
        'rgba(230, 52, 9, 1)',
      ],
      borderWidth: 2,
      borderRadius: 6,
      hoverOffset: 12,
      spacing: 2,
    }],
  };
};

export const getTotalOrdenes = (r) => Number(r?.total ?? r?.Total ?? 0);

export const hasChartData = (dataset) => {
  const values = dataset?.datasets?.[0]?.data ?? [];
  return values.some(v => Number(v) > 0);
};

// Bar de categorías
export const buildCategoriasBarData = (cats = [], modo = 'monto') => {
  const labels = cats.map(c => c.nombreCategoria);
  const data = cats.map(c => (modo === 'monto' ? Number(c.montoVentas || 0) : Number(c.unidadesVendidas || 0)));
  const isMonto = modo === 'monto';

  return {
    labels,
    datasets: [{
      label: isMonto ? 'Monto Ventas ($)' : 'Unidades Vendidas',
      data,
      backgroundColor: isMonto ? 'rgba(230, 52, 9, 0.82)' : 'rgba(70, 108, 203, 0.82)',
      borderColor: isMonto ? 'rgba(230, 52, 9, 1)' : 'rgba(70, 108, 203, 1)',
      borderWidth: 0,
      borderRadius: 10,
      borderSkipped: false,
      barThickness: 18,
      maxBarThickness: 22,
      hoverBackgroundColor: isMonto ? 'rgba(230, 52, 9, 0.95)' : 'rgba(70, 108, 203, 0.95)',
    }],
  };
};

const currencyFmt = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 });
export const getBarOptions = (modo = 'monto') => {
  const isMonto = modo === 'monto';
  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      title: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(33, 37, 41, 0.92)',
        titleColor: '#ffffff',
        bodyColor: '#f8f9fa',
        padding: 12,
        displayColors: false,
      }
    },
    scales: {
      y: {
        grid: { display: false, drawBorder: false },
        border: { display: false },
        ticks: {
          autoSkip: false,
          color: '#4b5563',
          font: { size: 11, weight: '600' },
        },
      },
      x: {
        grid: {
          color: 'rgba(118, 120, 122, 0.12)',
          drawBorder: false,
        },
        border: { display: false },
        ticks: {
          precision: 0,
          color: '#6b7280',
          font: { size: 11 },
          callback: (v) => (isMonto ? currencyFmt.format(v) : v),
        },
      },
    },
  };
};
